import type { OwnCashier, OwnCashierProfile } from './types'

/** Ввод формы карточки: строки как набраны. */
export interface OwnCashierProfileInput { lastName: string; firstName: string; middleName: string; position: string }

export const emptyProfileInput: OwnCashierProfileInput = { lastName: '', firstName: '', middleName: '', position: '' }

/** Ввод формы из карточки. У записи прежнего редактора связей ФИО пусто: администратор заполняет его, глядя на отображаемое имя в заголовке. */
export function profileInputOf(cashier: OwnCashier): OwnCashierProfileInput {
  return { lastName: cashier.lastName ?? '', firstName: cashier.firstName ?? '', middleName: cashier.middleName ?? '', position: cashier.position ?? '' }
}

const squeeze = (value: string) => value.trim().split(/\s+/).filter((part) => part !== '').join(' ')

/** ФИО и должность к отправке: пробелы сжаты, пустые отчество и должность — `null`. Длины и правила окончательно проверяет сервер. */
export function profileOf(input: OwnCashierProfileInput): OwnCashierProfile {
  const middleName = squeeze(input.middleName); const position = squeeze(input.position)
  return { lastName: squeeze(input.lastName), firstName: squeeze(input.firstName), middleName: middleName === '' ? null : middleName, position: position === '' ? null : position }
}

/** Что мешает сохранить ФИО — словами экрана; `null` — можно отправлять. */
export function profileProblem(input: OwnCashierProfileInput): string | null {
  const profile = profileOf(input)
  return profile.lastName === '' || profile.firstName === '' ? 'Укажите фамилию и имя кассира.' : null
}

/**
 * Что мешает задать код — словами экрана; `null` — можно отправлять. Код — произвольный секрет (PIN, буквы-цифры, токен, штрихкод):
 * проверяем только длину (пределы приходят с сервера) и запрет пробелов. Повторы и простые коды разрешены (решение владельца 04.11.2026).
 */
export function codeProblem(code: string, minLength: number, maxLength: number): string | null {
  if (code.length < minLength || code.length > maxLength) return `Код — от ${minLength} до ${maxLength} знаков.`
  if (/\s/.test(code)) return 'Код — без пробелов.'
  return null
}

/** Совпадает ли имя кассира источника с фамилией кассира: только подсказка, связь ставит человек. */
export function sameSurname(name: string, cashier: OwnCashier): boolean {
  const surname = (cashier.lastName ?? cashier.displayName.split(' ')[0] ?? '').toLocaleLowerCase('ru-RU')
  return surname !== '' && name.toLocaleLowerCase('ru-RU').includes(surname)
}
